import React from 'react';
import { X, Crown } from 'lucide-react';
import { isVipActive, formatVipExpiry } from './constants';

const VipDialog = ({ customer, form, setForm, onConfirm, onClose, loading }) => {
  if (!customer) return null;
  const active = isVipActive(customer);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm">
        <div className="p-5 border-b flex justify-between items-center">
          <h3 className="font-bold text-gray-800 flex items-center gap-2">
            <Crown className="w-5 h-5 text-yellow-600" />
            {active ? '续费 VIP' : '开通 VIP'}
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-5 space-y-4">
          <p className="text-sm text-gray-600">客户：<span className="font-medium">{customer.name || customer.username}</span></p>
          {active && (
            <div className="flex items-center gap-3">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="radio" name="vip_action" checked={form.is_vip}
                  onChange={() => setForm({ ...form, is_vip: true })} />
                <span className="text-sm">续费 VIP</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="radio" name="vip_action" checked={!form.is_vip}
                  onChange={() => setForm({ ...form, is_vip: false })} />
                <span className="text-sm text-red-600">取消 VIP</span>
              </label>
            </div>
          )}
          {form.is_vip && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">续费时长</label>
              <div className="grid grid-cols-4 gap-2">
                {[1, 3, 6, 12].map(m => (
                  <button key={m} type="button"
                    onClick={() => setForm({ ...form, months: m })}
                    className={`py-2 rounded-lg text-sm font-medium border transition-colors ${
                      form.months === m
                        ? 'bg-yellow-500 text-white border-yellow-500'
                        : 'bg-white text-gray-700 border-gray-300 hover:border-yellow-400'
                    }`}>
                    {m}个月
                  </button>
                ))}
              </div>
              {active && (
                <p className="text-xs text-gray-400 mt-2">
                  当前到期：{formatVipExpiry(customer)}，续费后延长 {form.months} 个月
                </p>
              )}
            </div>
          )}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">备注</label>
            <input type="text" value={form.note}
              onChange={e => setForm({ ...form, note: e.target.value })}
              placeholder="例：购买VIP套餐、赠送会员..."
              className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-yellow-400" />
          </div>
        </div>
        <div className="p-5 border-t flex gap-3">
          <button onClick={onClose}
            className="flex-1 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50">
            取消
          </button>
          <button onClick={onConfirm} disabled={loading}
            className={`flex-1 py-2 rounded-lg text-sm font-medium text-white transition-colors ${
              form.is_vip ? 'bg-yellow-500 hover:bg-yellow-600' : 'bg-red-500 hover:bg-red-600'
            } disabled:opacity-50`}>
            {loading ? '处理中...' : form.is_vip ? '确认开通/续费' : '确认取消'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VipDialog;